import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SaveButtonComponent } from './save-button.component';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    FlexLayoutModule,
    FlexLayoutModule,
  ],
  declarations: [SaveButtonComponent],
  exports: [SaveButtonComponent]
})
export class SaveButtonModule { }
